import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import store, { history } from 'Skelet/src/modules/store.js'

import 'sanitize.css/sanitize.css'
import 'Skelet/src/main.css'
import App from './containers/_app.js'
import registerServiceWorker from './registerServiceWorker';

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js